<template>
  <div style="color: white">
    <span style="color: white"></span>
    <v-dialog
      scrollable
      v-model="showSelectFeatureDialog"
      width="auto "
      max-width="600"
      height="400"
    >
      <v-card>
        <v-card-title> Velg tidsserie </v-card-title>
        <v-card-subtitle>Flere tidsserier på klikkpunktet</v-card-subtitle>

        <v-card-text>
          <v-list-item
            v-for="(timeserie, index) in selectTimeseries"
            :key="index"
          >
            <v-list-item-content>
              <v-btn @click="openPopup(timeserie)" depressed>{{
                getTimeSeriesButtonText(timeserie)
              }}</v-btn>
            </v-list-item-content>
          </v-list-item>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showSelectFeatureDialog = false">
            Lukk
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { loadModules } from "esri-loader";
import IdentifyService from "../../../services/IdentifyService";
import { MapPopupTable } from "@/components/index";
import { mapState, mapActions } from "vuex";
import Vue from "vue/dist/vue.js";
export default {
  name: "MapPopup",
  props: ["kartview", "selectionlayer", "tidsrom"],
  data() {
    return {
      params: null,
      tooltip: null,
      timeout: null,
      identifyService: null,
      waitForMounting: true,
      selectTimeseries: [],
    };
  },
  computed: {
    ...mapState([
      "kart",
      "queryExpression",
      "showPopups",
      "showStationsFromOtherActors",
      "queryExpressionStationsFromOtherActors",
      "showInfoDrawer",
    ]),
    showSelectFeatureDialog: {
      get() {
        return this.$store.state.showSelectFeatureDialog;
      },
      set(newValue) {
        return this.$store.dispatch("setShowSelectFeatureDialog", newValue);
      },
    },
  },
  methods: {
    ...mapActions([
      "setClickedTimeSeries",
      "setShowInfoDrawer",
      "setShowSelectFeatureDialog",
    ]),
    selectFeature: function(latitude, longitude) {
      if (latitude && longitude) {
        this.addSelectedGraphic(latitude, longitude);
      } else {
        this.clearSelectedGraphics();
      }
    },
    getTimeSeriesButtonText: function(timeSerie) {
      if (
        Object.prototype.hasOwnProperty.call(timeSerie.attributes, "objektType")
      ) {
        return (
          timeSerie.attributes.stasjonNavn +
          " (" +
          timeSerie.attributes.stasjonNr +
          ") " +
          timeSerie.attributes.stasjonParameter +
          " (versjon: " +
          timeSerie.attributes.versjon +
          ")"
        );
      } else {
        return (
          timeSerie.attributes.STASJONSNAVN +
          " (" +
          timeSerie.attributes.STASJONID +
          ") " +
          timeSerie.attributes.PARAMETERNAVN +
          " (versjon: " +
          timeSerie.attributes.VERSJON +
          ")"
        );
      }
    },
    openPopup: function(timeserie) {
      this.addSelectedGraphics(timeserie);
      this.setClickedTimeSeries([timeserie]);
      this.showSelectFeatureDialog = false;
      this.setShowInfoDrawer(true);
    },
    addSelectedGraphic: function(latitude, longitude) {
      loadModules(["esri/Graphic"]).then(([Graphic]) => {
        this.selectionlayer.add(
          new Graphic({
            geometry: {
              type: "point",
              longitude: longitude,
              latitude: latitude,
            },
            symbol: {
              type: "simple-marker",
              outline: {
                style: "none",
              },
              size: 20,
              color: [0, 197, 255, 0.63],
            },
          })
        );
      });
    },
    clearSelectedGraphics: function() {
      this.selectionlayer.removeAll();
    },
    addSelectedGraphics: function(timeserie) {
      this.selectionlayer.removeAll();
      this.selectionlayer.add(timeserie);
    },
    showPopup: function(mapPoint, response, useTooltip) {
      if (response.length > 0) {
        if (useTooltip) {
          this.tooltip.innerHTML =
            "<strong>" +
            response[0].attributes.stasjonNavn +
            " (" +
            response[0].attributes.stasjonNr +
            ")" +
            (response.length > 1 ? " +" + (response.length - 1) : "") +
            "</strong>";
          this.tooltip.style.display = "block";
          this.tooltip.style.color = "white";
        } else {
          if (response.length > 1) {
            this.showSelectFeatureDialog = true;
            this.selectTimeseries = response;
          } else {
            this.setShowInfoDrawer(true);
            this.setClickedTimeSeries(response);
            this.addSelectedGraphics(response[0]);
          }
        }
      } else {
        this.addSelectedGraphics(response[0]);

        this.setClickedTimeSeries(response);
        this.setShowInfoDrawer(false);
      }
    },
    mountChartPopup: function(newValue, timePeriod) {
      let id =
        "popupContent" +
        newValue.attributes.stasjonNr.split(".").join("") +
        newValue.attributes.stasjonParameterKode +
        newValue.attributes.versjon;

      var ComponentClass = Vue.extend(MapPopupTable);
      var instance = new ComponentClass({
        propsData: {
          data: {
            stasjonNr: newValue.attributes.stasjonNr,
            stasjonParameterKode: newValue.attributes.stasjonParameterKode,
            versjon: newValue.attributes.versjon,
            stasjonParameter: newValue.attributes.stasjonParameter,
            timePeriod: timePeriod,
          },
          tidsserie: newValue.attributes,
        },
      });
      setTimeout(() => {
        instance.$mount("#" + id);
      }, 100);
    },
    showTooltip: function(event) {
      clearTimeout(this.timeout);
      this.tooltip.style.display = "none";
      this.timeout = setTimeout(() => {
        var point = this.kartview.toMap({ x: event.x, y: event.y });
        event.mapPoint = point;
        this.tooltip.style.left = event.native.pageX + "px";
        this.tooltip.style.top = event.native.pageY + "px";
        this.tooltip.style.color = "white";
        this.tooltip.style.background = "white";
        this.params.returnGeometry = false;
        this.executeIdentifyTask(event, this.queryExpression, true);
      }, 500);
    },
    setIdentifyParams: function() {
      loadModules(["esri/tasks/support/IdentifyParameters"]).then(
        ([IdentifyParameters]) => {
          this.params = new IdentifyParameters();
          this.params.tolerance = 10;
          this.params.layerIds = [0];
          this.params.layerOption = "visible";
          this.params.returnGeometry = true;
          this.params.width = this.kartview.width;
          this.params.height = this.kartview.height;
        }
      );
    },
  },
  watch: {
    showInfoDrawer: function(newVal) {
      if (newVal === false) {
        this.selectionlayer.removeAll();
        this.waitForMounting = true;
      }
    },
  },
  created: function() {
    this.$eventHub.$on("map-select-feature", this.selectFeature);
  },
  mounted: function() {
    loadModules(["dojo/on"]).then(([on]) => {
      this.tooltip = document.querySelectorAll(".maptooltip")[0];

      on(
        this.kartview,
        "click",
        function(evt) {
          if (this.showPopups) {
            this.params.returnGeometry = true;
            this.identifyService = new IdentifyService(
              this.params,
              this.kartview,
              this.selectionlayer,
              this.kart.kartlag
            );
            this.identifyService
              .executeIdentifyTask(
                evt,
                this.queryExpression,
                this.queryExpressionStationsFromOtherActors,
                this.showStationsFromOtherActors,
                false
              )
              .then((result) => {
                this.showPopup(
                  result.mapPoint,
                  result.response,
                  result.useTooltip
                );
              });
          }
        }.bind(this)
      );

      this.setIdentifyParams();

      this.kartview.popup.watch("selectedFeature", (newValue) => {
        if (
          newValue &&
          Object.prototype.hasOwnProperty.call(
            newValue.attributes,
            "layerName"
          ) &&
          newValue.attributes.layerName === "tidsserier"
        ) {
          if (this.waitForMounting) {
            setTimeout(() => {
              this.waitForMounting = false;
              this.mountChartPopup(newValue, this.tidsrom);
            }, 1000);
          } else {
            this.mountChartPopup(newValue, this.tidsrom);
          }
        }
      });

      this.kartview.popup.watch("visible", (newValue) => {
        if (newValue === false) {
          this.selectionlayer.removeAll();
          this.waitForMounting = true;
        }
      });
    });
  },
};
</script>
